<template>
    <div class="thumbs-up-thumbs-down">
        <div v-if="showButtons">
            <pendo-icon-button
                v-pendo-tooltip="{ content: $t('askPendo.thumbsUpThumbsDown.Provide positive feedback'), placement: 'bottom' }"
                icon="thumbs-up"
                icon-size="16"
                @click="handleThumbsUp" />
            <pendo-icon-button
                v-pendo-tooltip="{ content: $t('askPendo.thumbsUpThumbsDown.Provide negative feedback'), placement: 'bottom' }"
                icon="thumbs-down"
                icon-size="16"
                @click="handleThumbsDown" />
        </div>
        <div
            v-else-if="showFeedbackInput"
            class="thumbs-up-thumbs-down__feedback-input">
            <pendo-icon-button
                class="thumbs-up-thumbs-down__submitted-icon"
                icon="thumbs-down"
                icon-size="16" />
            <div
                class="thumbs-up-thumbs-down__feedback-input-main"
                @keydown.enter="handleKeyDown">
                <pendo-input
                    :value="feedbackText"
                    type="textarea"
                    :rows="3"
                    :placeholder="$t('askPendo.thumbsUpThumbsDown.Why such the negative feedback?')"
                    @input="handleFeedbackInput" />
                <div class="thumbs-up-thumbs-down__feedback-input-actions">
                    <pendo-button
                        type="subtle"
                        size="mini"
                        :label="$t('askPendo.thumbsUpThumbsDown.No additional comments')"
                        @click="handleNoComments" />
                    <pendo-button
                        :disabled="!feedbackText.trim()"
                        size="mini"
                        :label="$t('askPendo.thumbsUpThumbsDown.Submit')"
                        @click="submitFeedback" />
                </div>
            </div>
        </div>
        <div
            v-else
            class="thumbs-up-thumbs-down__submitted-message">
            <pendo-icon-button
                class="thumbs-up-thumbs-down__submitted-icon"
                :icon="submittedIcon"
                icon-size="16" />
            <span class="thumbs-up-thumbs-down__submitted-text">{{ feedbackSubmittedText }}</span>
        </div>
    </div>
</template>

<script>
import { PendoButton, PendoIconButton, PendoInput, PendoTooltip } from '@pendo/components';

export default {
    name: 'ThumbsUpThumbsDown',
    components: {
        PendoButton,
        PendoIconButton,
        PendoInput,
    },
    directives: {
        PendoTooltip,
    },
    emits: ['thumbs-up', 'thumbs-down', 'feedback-submitted'],
    data () {
        return {
            showFeedbackInput: false,
            feedbackText: '',
            showButtons: true,
            submittedIcon: '',
        };
    },
    computed: {
        feedbackSubmittedText () {
            const showThankYou = this.submittedIcon === 'thumbs-up' || this.feedbackText === '';

            return showThankYou ? this.$t('askPendo.thumbsUpThumbsDown.Thanks for your feedback!') : this.feedbackText;
        },
    },
    methods: {
        handleThumbsUp () {
            this.$emit('thumbs-up');
            this.showButtons = false;
            this.submittedIcon = 'thumbs-up';
        },
        handleThumbsDown () {
            this.$emit('thumbs-down');
            this.showButtons = false;
            this.showFeedbackInput = true;
            this.submittedIcon = 'thumbs-down';
        },
        handleFeedbackInput ($event) {
            this.feedbackText = $event;
        },
        submitFeedback () {
            if (this.feedbackText.trim()) {
                this.$emit('feedback-submitted', this.feedbackText);
                this.showFeedbackInput = false;
            }
        },
        handleNoComments () {
            this.showFeedbackInput = false;
            this.feedbackText = '';
        },
        handleKeyDown (event) {
            if (event.key === 'Enter' && !event.shiftKey) {
                event.preventDefault();
                this.submitFeedback();
            }
        },
    },
};
</script>

<style scoped lang="less">
:deep(.pendo-icon-button) {
    margin: 0;
}
.thumbs-up-thumbs-down {
    display: flex;
    align-items: center;
    margin-left: 6px;

    &__feedback-input {
        display: flex;
        align-items: flex-start;
        width: 388px;
    }

    &__feedback-input-main {
        gap: 12px;
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    &__feedback-input-actions {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: 100%;
        gap: 8px;
    }

    &__submitted-message {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        width: 388px;
    }

    &__submitted-icon {
        border-color: transparent;
        background-color: var(--palette-gray-30);
        color: var(--palette-gray-100);
        cursor: default;
        margin-right: 12px;
    }

    &__submitted-text {
        color: var(--palette-gray-70);
        font-size: 12.642px;
        font-weight: 400;
        line-height: 150%;
        width: 344px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>
